import dedent from "dedent";

export const GET_ORDERS = dedent`
  query PendingSchedulerTasks {
    pendingSchedulerTasks {
      id
      code
      creationDate
      status
    }
  }
`;
